export default __webpack_public_path__ + "static/media/eqqe.995d4011.svg";